import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styles from './loadingLayer.scss'

const LoadingLayer = (props) => {
  const { active, loading } = props

  const loadingLayerClass = classNames(styles.loadingLayer, {
    [styles.active]: loading || active
  })

  return (
    <div className={loadingLayerClass}>
      <progress className={styles.circular} />
    </div>
  )
}

LoadingLayer.defaultProps = {
  active: false,
  loading: false
}

LoadingLayer.propTypes = {
  active: PropTypes.bool,
  loading: PropTypes.bool
}

export default LoadingLayer
